module.exports = __webpack_public_path__ + "img/mobile-spectrum-BusinessTools.75e70c18.png";